export const SAVE = 'stepOtherStarr.SAVE';
export const VALUE_CHANGED = 'stepOtherStarr.VALUE_CHANGED';
export const LOAD = 'stepOtherStarr.VALUE_LOAD';
export const NEXT = 'stepOtherStarr.NEXT';
export const RESET = 'stepOtherStarr.RESET';
export const RESET_SUB_BENEFIT = 'stepOtherStarr.RESET_SUB_BENEFIT';
export const RESET_BENEFIT_OTHER = 'stepOtherStarr.RESET_BENEFIT_OTHER';
export const RESET_ACCIDENTAL_DEATH_AND_DISMEMBERMENT = 'stepOtherStarr.RESET_ACCIDENTAL_DEATH_AND_DISMEMBERMENT';
export const RESET_BURIAL = 'stepOtherStarr.RESET_BURIAL';
export const RESET_REPATRIATION = 'stepOtherStarr.RESET_REPATRIATION';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '7',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepOther/constants.js